import { useDispatch, useSelector } from "react-redux";
import { LayoutContainer } from "../styleComponents/LayoutStyle"
import Axios from "../utils/httpClient";
import Footer from "./Footer";
import Header from "./Header";
import NormalHeader from "./NormalHeader";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getToken } from "../utils/tokenStorge";

const Layout = ({children, showLoginButton = false}) =>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector(state => state);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(()=>{
        if (!showLoginButton) {
            const token = getToken();
            if (token && !user?.id) {
                // Token exists but user not loaded - fetch profile
                getProfile();
            } else if (!token) {
                // No token - redirect to login
                navigate('/login');
            } else {
                // User already loaded
                setIsLoading(false);
            }
        } else {
            setIsLoading(false);
        }
    }, [showLoginButton]);
    
    useEffect(() => {
        // When user is loaded, stop loading
        if (user?.id) {
            setIsLoading(false);
        }
    }, [user?.id]);
    
    const getProfile = () => {
        Axios().get('api/v1/account/profile/')
        .then((res)=>{
            dispatch({type: "SET_USER", payload: res?.data??{}});
            setIsLoading(false);
        }).catch(e=>{
            // If there's an error fetching profile, clear user data and redirect to login
            dispatch({type: "SET_USER", payload: {}});
            setIsLoading(false);
            navigate('/login')
        })
    }
    
    return(<>
        <LayoutContainer>
            {showLoginButton ? <NormalHeader /> : <Header />}
            {children}
            <Footer/>
        </LayoutContainer>
    </>)
}
export default Layout;